export default __webpack_public_path__ + "static/media/2-pieces-lower-mantle.e3852c27.svg";